// remember to update confluence page after modifying this file
// https://dop-orange.atlassian.net/wiki/spaces/WUWA/pages/1827602540/Nju+Tagging+DataLayer

interface IPushNumberSettingsEventProps {
  eventName: string;
  status: boolean | undefined;
}

export function pushNumberSettingsEvent({
  eventName,
  status,
}: IPushNumberSettingsEventProps) {
  if ("dataLayer" in window) {
    window.dataLayer.push({
      event: "activity_service_change",
      event_name: eventName,
      status: status ? "active" : "inactive",
      event_type: "click",
    });
  }
}
